import { render, staticRenderFns } from "./ParticipantVotingRulesIndicator.vue?vue&type=template&id=035bd776&"
import script from "./ParticipantVotingRulesIndicator.vue?vue&type=script&lang=js&"
export * from "./ParticipantVotingRulesIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports